export default "/_next/static/fonts/82b0ddc927b20c7fe29c681becdfc688.woff2";